export interface TyroPayRequestResponse {
  status: PayRequestStatus;
  threeDSecure?: ThreeDSecure;
  errorCode?: string;
  errorMessage?: string;
  gatewayCode?: string;
}

export enum PayRequestStatus {
  AWAITING_PAYMENT_INPUT = 'AWAITING_PAYMENT_INPUT',
  AWAITING_AUTHENTICATION = 'AWAITING_AUTHENTICATION',
  PROCESSING = 'PROCESSING',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
  VOIDED = 'VOIDED',
}

export interface ThreeDSecure {
  status: ThreeDSecureStatus;
  methodURL?: string;
  challengeURL?: string;
}

export enum ThreeDSecureStatus {
  AWAITING_3DS_METHOD = 'AWAITING_3DS_METHOD',
  AWAITING_AUTH = 'AWAITING_AUTH',
  AWAITING_CHALLENGE = 'AWAITING_CHALLENGE',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
}

export enum HttpStatusCode {
  OK = 200,
  CREATED = 201,
  ACCEPTED = 202,
  BAD_REQUEST = 400,
  FORBIDDEN = 403,
  INTERNAL_SERVER_ERROR = 500,
  CONFLICT = 409,
}
